module.exports = __webpack_public_path__ + "static/media/1-mai-1.1aaea28b.jpg";